import {
  applyBrandColors,
  applyBrandContrastVars
} from '~/ui/buttons/helpers/getContrastingColor';

/**
 * Recompute on-accent / focus / link tokens from the current --color-accent-dk
 * when the learner surface flips between light and dark.
 */
export const refreshBrandContrastForSurface = (
  surfaceIsDark: boolean,
  element: HTMLElement = document.documentElement
): void => {
  const computed = getComputedStyle(element);
  const accent = computed.getPropertyValue('--color-accent-dk').trim();
  const pageCanvas = computed.getPropertyValue('--color-accent-lt').trim();
  applyBrandContrastVars(element.style, accent, surfaceIsDark, pageCanvas);
};

export { applyBrandColors };
